module.exports = __webpack_public_path__ + "static/media/streak-video.835edc91.mp4";